import { ENTRY, PINNED } from "../../apollo/fields"

import { CURRENT_ENTRY } from "../../apollo/queries"
import { CURRENT_ENTRY_DATA } from "../../apollo/data"
import client from "../../apollo/client"
import { gql } from "@apollo/client"
import { navigate } from "@reach/router"
import cache from "../../apollo/cache"
import { clone } from "lodash"

const claimRefetch = async refetchFnc => {
  return async () => {
    const run = await refetchFnc()
    const key = Object.keys(run.data)[0]
    return run.data[key]
  }
}

/**
 * Returns a promised with a useQuery refetch operation
 * stored in it.  The ressolved promise value is the queried
 * data property.
 * @usage const storedQuery = storeQuery(useQuery(SOME_QUERY))
 * @param {Promise} results a useQuery operation
 */
export const storeQuery = (results, queryStateReference) => {
  if (!results || queryStateReference) return null
  return claimRefetch(results.refetch)
}

/**
 * Retrieves the query data from useQuery operation
 * @param {Object} operation the useQuery evokation
 */
export const extractQuery = operation => {
  if (operation.loading || !operation.data) return null
  const key = Object.keys(operation.data)[0]
  return operation.data[key]
}

/**
 * Safely reads data from Apollo cache and populates it with
 * default data if not exists, instead of throwing.
 * @param {String} query the gql template tag query
 * @param {Object} defaultData data to populate if missing
 * @param {Object} variables associated query vars
 */
export const safeReadQuery = (query, defaultData, variables) => {
  let value
  try {
    if (variables) value = cache.readQuery({ query, variables })
    else value = cache.readQuery({ query })
  } catch (e) {
    debugger //_
    client.writeData({ data: defaultData })
  }
  const _value = clone(value) || defaultData
  return _value
}

export class Cashew {
  constructor(client) {
    this.client = client
    this.cache = client.cache
  }
  testMethod() {}

  getEntry(key) {
    if (!key) {
      console.warn(`LOG: [Cache]:  -> getEntry no key provided.`)
      navigate("/a/account")
      return
    }

    let entry = {}
    try {
      entry = this.client.readFragment({
        id: key,
        fragment: gql`
          fragment entry on UserEntry {
            ${ENTRY}
          }
        `,
      })
      entry.cache_time = new Date().getTime()
      console.log(`LOG: [Cache] retrieved entry from cache ${key}`, { entry })
    } catch (error) {
      console.warn(`LOG: [Cache] failed to retrieve entry ${key} from cache.'`)
      console.error(error)
    }
    return entry
  }

  writeCurrentEntry(entry) {
    // this.client.writeData({ data: { currentEntry: entry } })
    entry = entry || CURRENT_ENTRY_DATA
    try {
      client.writeQuery({
        query: CURRENT_ENTRY,
        data: {
          currentEntry: { ...entry, ...{ __typename: "CurrentEntry" } },
        },
      })
      this.client.writeFragment({
        id: entry.key,
        fragment: gql`
          fragment entry on UserEntry {
            ${ENTRY}
          }
        `,
        data: entry,
      })
    } catch (error) {
      // Case: user attempts to write new entry after editing entry
      // where edited entry data is set as `currentEntry` in cache.
      console.warn(`LOG: [Cache] failed to write currentEntry to cache.'`)
      console.error(error)
    }
  }

  /**
   * Updates the cache after being pinned on Journal
   * Entries page
   * @param {Object} entry the entry recorde
   */
  updatePinnedEntry(entry) {
    this.client.writeFragment({
      id: entry.key,
      fragment: gql`
        fragment updatedEntry on UserEntry {
          ${PINNED}
        }
      `,
      data: {
        pinned: !entry.pinned,
      },
    })
    // Read updated
    const updatedEntry = this.client.readFragment({
      id: entry.key,
      fragment: gql`
        fragment updatedEntry on UserEntry {
          ${PINNED}
        }
      `,
    })
    // Return updated entry
    return { ...entry, ...updatedEntry }
  }
}
